import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "84",
  height: "85",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M41.959.833C18.959.833.333 19.5.333 42.5S18.96 84.166 41.96 84.166C65 84.166 83.666 65.5 83.666 42.5 83.667 19.5 65 .833 41.958.833Zm.041 75c-18.416 0-33.333-14.917-33.333-33.333C8.667 24.083 23.584 9.166 42 9.166c18.417 0 33.334 14.917 33.334 33.334 0 18.416-14.917 33.333-33.334 33.333ZM37.834 55h8.333v8.333h-8.334V55Zm0-33.334h8.333v25h-8.334v-25Z",
  fill: "#D50000"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render };